<template>
  <div class="relative">
    <v-textarea
      v-if="isVuetify"
      :type="type"
      :class="{ invalid: error }"
      :placeholder="placeholder"
      :rows="rows"
      :value="model"
      :error="error"
      :maxlength="maxlength"
      :minlength="minlength"
      solo
      :auto-grow="true"
      :disabled="disabled"
      @change="updateParent($event)"
      @keypress="validateFormat($event)"
    />
    <textarea
      v-else
      :type="type"
      class="form-control input-textarea"
      :class="{ invalid: error }"
      :placeholder="placeholder"
      :rows="rows"
      :value="model"
      :error="error"
      :maxlength="maxlength"
      :minlength="minlength"
      :disabled="disabled"
      @change="updateParent($event)"
      @keypress="validateFormat($event)"
    />
    <slot name="icon" />
    <span class="error-message" v-if="error">{{ errorMessage }}</span>
  </div>
</template>

<style lang="scss" scoped>
.input-textarea {
  // border-radius: 8px;
}
</style>

<script>
export default {
  props: {
    maxLength: String,
    minLength: String,
    errorMessage: String,
    placeholder: String,
    rows: Number,
    type: String,
    model: [String, Number],
    error: Boolean,
    regex: RegExp,
    disabled: Boolean,
    notSmallThan: Number,
    maxValue: Number,
    isVuetify: Boolean
  },
  data() {
    return {};
  },
  watch: {},
  methods: {
    validateFormat(evt) {
      let theEvent = evt || window.event;
      if (this.regex) this.allowFormat(theEvent);
    },
    allowFormat(evt) {
      // Handle paste
      let key;
      if (evt.type === "paste") {
        key = event.clipboardData.getData("text/plain");
      } else {
        // Handle key press
        key = evt.keyCode || evt.which;
        key = String.fromCharCode(key);
      }
      if (!this.regex.test(key)) {
        evt.returnValue = false;
        if (evt.preventDefault) evt.preventDefault();
      }
    },
    updateParent(e) {
      this.$emit("update:error", false);
      e.target.classList.remove("invalid");
      let value = e.target.value;
      if (value && value.trim() !== "" && !isNaN(value)) {
        value = value;
      }
      if (this.maxValue) {
        value = Math.min(this.maxValue, value);
        this.$emit("update:model", value);
      }
      if (this.notSmallThan || this.notSmallThan === 0) {
        value = Math.max(this.notSmallThan + 1, value);
        e.target.value = value;
        this.$emit("update:model", value);
      }
      this.$emit("update:model", value);
    }
  }
};
</script>
